import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-fullscreen",
  "use": "icon-icon-fullscreen-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-icon-fullscreen\"><path d=\"M428.16 69.76v358.4h-358.4M198.144 300.288L46.08 148.224 147.456 46.848 299.52 198.912zM69.76 593.28h358.4v358.4M299.968 824.32l-152 152.064-101.376-101.376 152-152.064zM954.88 428.16h-358.4v-358.4M725.12 198.016L877.312 45.952l101.376 101.376-152.064 152zM596.48 954.24v-358.4h358.4M825.472 722.88l152.064 152.064-101.376 101.376-152.064-152.064z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/icon-fullscreen.svg
// module id = Tl9l
// module chunks = 3